/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type DuplicateAnalysisNotFoundErrorCode =
  (typeof DuplicateAnalysisNotFoundErrorCode)[keyof typeof DuplicateAnalysisNotFoundErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DuplicateAnalysisNotFoundErrorCode = {
  analysis_not_found: "analysis_not_found",
  nsure_agent_not_found: "nsure_agent_not_found",
  mango_agent_not_found: "mango_agent_not_found",
} as const;
